import { getFeatureFlag } from 'app/ducks/featureFlags/selectors'
import { Store } from 'app/redux/Store'
import { surveyBuilder } from 'app/views/routes'
import { SURVEY_MANAGEMENT_FLAG } from 'app/views/survey/surveyManagementFlag'

// Menu entry for the survey builder. Unlike the route itself (reachable while
// feature flags are still loading, see `surveyBuilder` in views/routes.js),
// it's only shown once `survey_management` is known to be on. Kept out of
// views/routes.js so it isn't registered as a second route.
export const surveyBuilderNavigation = {
  ...surveyBuilder,
  userCondition: () => getFeatureFlag(Store.getState(), SURVEY_MANAGEMENT_FLAG),
}
